/**
 * Shared helpers for summarizing the clinical data attached to a review item.
 * Kept in a non-component module so the review tables and the detail component
 * can share it without tripping react-refresh's "components only" rule.
 */

export interface ClinicalCounts {
  diagnoses: number;
  medications: number;
  allergies: number;
  total: number;
}

/** Count the clinical items that will be written to the chart on import. */
export function getClinicalCounts(patient: {
  diagnoses?: unknown[] | null;
  medications?: unknown[] | null;
  allergies?: unknown[] | null;
}): ClinicalCounts {
  const diagnoses = patient.diagnoses?.length ?? 0;
  const medications = patient.medications?.length ?? 0;
  const allergies = patient.allergies?.length ?? 0;
  return { diagnoses, medications, allergies, total: diagnoses + medications + allergies };
}
